import React from 'react'
import { MetaData } from 'components/MetaData'
import { FadeIn } from 'lib/ui/components'
import { Container } from './styled'
import { useCmsPageByPath } from 'lib/core/hooks'

export const CmsPage = () => {
  const { content_heading: contentHeading, content } = useCmsPageByPath()

  return (
    <>
      <MetaData
        type='CMS'
      />
      <Container>
        <FadeIn>
          <h1>
            {contentHeading}
          </h1>
          <div
            dangerouslySetInnerHTML={{
              __html: content
            }}
          />
        </FadeIn>
      </Container>
    </>
  )
}
